export const translations = {
  en: {
    // Navbar
    'participate': 'Participate',
    
    // Sidebar
    'dashboard': 'Dashboard',
    'tenant_management': 'Tenant Management',
    'all_tenants': 'All Tenants',
    'customers': 'Customers',
    'suppliers': 'Suppliers',
    'add_new_tenant': 'Add New Tenant',
    'user_management': 'User Management',
    'user_categories': 'User Categories',
    'all_users': 'All Users',
    'by_role': 'By Role',
    'add_new_user': 'Add New User',
    'products_overview': 'Products Overview',
    'all_products': 'All Products',
    'by_category': 'By Category',
    'orders_management': 'Orders Management',
    'all_orders': 'All Orders',
    'pending': 'Pending',
    'completed': 'Completed',
    'cancelled': 'Cancelled',
    'system_settings': 'System Settings',
    'audit_logs': 'Audit Log',
    'general_settings': 'General Settings',
    'email_templates': 'Email Templates',
    'system_logs': 'System Logs',
    'control_center': 'Control Center',
    
    // Tabs
    'overview': 'Overview',
    'tenants': 'Tenants',
    'users': 'Users',
    
    // Hero
    'united_nations': 'United Nations Climate Change Conference',
    'hero_description': 'Join world leaders, climate experts, and changemakers in Antalya for the 31st Conference of the Parties to address the climate crisis and build a sustainable future.',
    'register_now': 'Register Now',
    'learn_more': 'Learn More',
    
    // About
    'about_cop31': 'About COP 31',
    'about_description': "COP 31 marks a historic moment as Türkiye hosts the world's most important climate conference in the stunning Mediterranean city of Antalya. This gathering brings together nearly 200 countries to accelerate climate action, strengthen global cooperation, and chart a path toward a sustainable future.",
    'what_is_cop': 'What is COP?',
    'what_is_cop_text': 'The Conference of the Parties (COP) is the supreme decision-making body of the United Nations Framework Convention on Climate Change (UNFCCC). Since 1995, COP has been the platform where nations negotiate and coordinate global climate policy, from the Kyoto Protocol to the Paris Agreement.',
    'why_antalya': 'Why Antalya?',
    'why_antalya_text': "Antalya represents the perfect intersection of natural beauty and climate urgency. As a Mediterranean gateway, Türkiye bridges continents and cultures, making it an ideal host for fostering global climate dialogue. The region's unique biodiversity and climate challenges underscore the conference's mission.",
    
    // Türkiye Commitments
    'turkey_commitments': "Türkiye's Climate Commitments",
    'turkey_commitments_desc': 'As COP 31 host, Türkiye demonstrates leadership in climate action with ambitious national targets and regional initiatives.',
    
    // Focus Areas
    'key_focus_areas': 'Key Focus Areas',
    'focus_subtitle': 'COP 31 addresses critical climate challenges through four strategic pillars',
    'renewable_energy': 'Renewable Energy Transition',
    'mediterranean_bio': 'Mediterranean Biodiversity',
    'sustainable_cities': 'Sustainable Cities',
    'climate_finance': 'Climate Finance & Justice',
    
    // Schedule
    'conference_schedule': 'Conference Schedule',
    'schedule_subtitle': 'Ten days of intensive negotiations, dialogues, and collaborative action',
    
    // News
    'latest_news': 'Latest News & Updates',
    'news_subtitle': 'Stay informed about COP 31 preparations and climate action progress',
    'view_all_news': 'View All News',
    
    // Registration
    'join_us': 'Join Us at COP 31',
    'registration_desc': 'Registration for COP 31 will open in early 2026. Multiple participation categories are available for governments, NGOs, private sector, media, and observers.',
    'registration_requirements': 'Registration Requirements',
    'pre_register': 'Pre-Register Your Interest',
    
    // Partners
    'partners_supporters': 'Partners & Supporters',
    
    // Footer
    'quick_links': 'Quick Links',
    'contact': 'Contact',
    
    // Ultra Admin
    'ultra_admin': 'Ultra Admin',
    'control_center': 'COP 31 Platform Control Center',
    'sign_in': 'Sign In',
    'access_admin': 'Access the system administration panel',
    'email_address': 'Email Address',
    'password': 'Password',
    'remember_me': 'Remember me',
    'forgot_password': 'Forgot password?',
    'signing_in': 'Signing in...',
    'pre_live_testing': 'Pre-Live Testing',
    'quick_access': 'Quick Access (Bypass)',
    'secure_admin': 'Secure admin access.',
    'dashboard': 'Dashboard',
    'welcome_back': 'Welcome back, Ultra Admin',
    'logout': 'Logout',
    'loading_dashboard': 'Loading dashboard...',
    'total_tenants': 'Total Tenants',
    'total_users': 'Total Users',
    'total_products': 'Total Products',
    'total_orders': 'Total Orders',
    'active': 'active',
    'across_all': 'Across all tenants',
    'from_suppliers': 'From suppliers',
    'this_week': 'this week',
    'system_overview': 'System Overview',
    'customer_tenants': 'Customer Tenants',
    'supplier_tenants': 'Supplier Tenants',
    'orgs_placing': 'Organizations placing orders',
    'orgs_providing': 'Organizations providing products',
    'tenant_management': 'Tenant Management',
    'user_management': 'User Management',
    'user_categories': 'User Categories',
    'add_tenant': 'Add Tenant',
    'add_user': 'Add User',
    'no_tenants': 'No tenants found',
    'no_users': 'No users found',
    'customer_tenants': 'Customer Tenants',
    'supplier_tenants': 'Supplier Tenants',
    'orgs_placing': 'Organizations placing orders',
    'orgs_providing': 'Organizations providing products',
    'made_with': 'Made with Emergent',
    
    // Customer/Supplier common
    'my_products': 'My Products',
    'my_orders': 'My Orders',
    'profile': 'Profile',
    'browse_products': 'Browse Products',
    'search_products': 'Search products...',
    'category': 'Category',
    'all_categories': 'All Categories',
    'price': 'Price',
    'stock': 'Stock',
    'add_to_cart': 'Add to Cart',
    'view_details': 'View Details',
    'create_order': 'Create Order',
    'order_history': 'Order History',
    'order_id': 'Order ID',
    'order_date': 'Order Date',
    'total_amount': 'Total Amount',
    'status': 'Status',
    'items': 'Items',
    'supplier': 'Supplier',
    'customer': 'Customer',
    'quantity': 'Quantity',
    'unit_price': 'Unit Price',
    'subtotal': 'Subtotal',
    'add_product': 'Add Product',
    'edit_product': 'Edit Product',
    'delete_product': 'Delete Product',
    'product_name': 'Product Name',
    'description': 'Description',
    'save': 'Save',
    'cancel': 'Cancel',
    'confirm': 'Confirm',
    'update_status': 'Update Status',
    'in_progress': 'In Progress',
    
    // Green Zone Layout
    'blue_zone_layouts': 'Blue Zone Layouts',
    'add_participant': 'Add Participant',
    'participant_email': 'Participant Email',
    'country': 'Country',
    'select_country': 'Select Country',
    'authorized_persons': 'Authorized Persons',
    'full_name': 'Full Name',
    'mobile_phone': 'Mobile Phone',
    'phone': 'Phone',
    'email': 'Email',
    'title': 'Title',
    'add_person': 'Add Person',
    'create_layout': 'Create Layout',
    'layout_wizard': 'Layout Wizard',
    'base_dimensions': 'Base Dimensions',
    'width_m': 'Width (m)',
    'height_m': 'Height (m)',
    'add_indent': 'Add Indentation',
    'add_extrusion': 'Add Extrusion',
    'open_sides': 'Open Sides',
    'north': 'North',
    'south': 'South',
    'east': 'East',
    'west': 'West',
    'total_area': 'Total Area',
    'preview': 'Preview',
    'my_layout': 'My Stand Layout',
    'all_participants': 'All Participants'
  },
  tr: {
    // Navbar
    'participate': 'Katıl',
    
    // Sidebar
    'dashboard': 'Panel',
    'tenant_management': 'Kiracı Yönetimi',
    'all_tenants': 'Tüm Kiracılar',
    'customers': 'Müşteriler',
    'suppliers': 'Tedarikçiler',
    'add_new_tenant': 'Yeni Kiracı Ekle',
    'user_management': 'Kullanıcı Yönetimi',
    'user_categories': 'Kullanıcı Kategorileri',
    'all_users': 'Tüm Kullanıcılar',
    'by_role': 'Role Göre',
    'add_new_user': 'Yeni Kullanıcı Ekle',
    'products_overview': 'Ürün Genel Bakış',
    'all_products': 'Tüm Ürünler',
    'by_category': 'Kategoriye Göre',
    'orders_management': 'Sipariş Yönetimi',
    'all_orders': 'Tüm Siparişler',
    'pending': 'Beklemede',
    'completed': 'Tamamlandı',
    'cancelled': 'İptal Edildi',
    'system_settings': 'Sistem Ayarları',
    'audit_logs': 'Audit Log',
    'general_settings': 'Genel Ayarlar',
    'email_templates': 'E-posta Şablonları',
    'system_logs': 'Sistem Kayıtları',
    'control_center': 'Kontrol Merkezi',
    
    // Tabs
    'overview': 'Genel Bakış',
    'tenants': 'Kiracılar',
    'users': 'Kullanıcılar',
    
    // Hero
    'united_nations': 'Birleşmiş Milletler İklim Değişikliği Konferansı',
    'hero_description': 'İklim kriziyle mücadele etmek ve sürdürülebilir bir gelecek inşa etmek için dünya liderleri, iklim uzmanları ve değişim yaratıcıları ile Antalya\'da 31. Taraflar Konferansı\'nda buluşun.',
    'register_now': 'Şimdi Kaydol',
    'learn_more': 'Daha Fazla Bilgi',
    
    // About
    'about_cop31': 'COP 31 Hakkında',
    'about_description': 'COP 31, Türkiye\'nin dünyanın en önemli iklim konferansına ev sahipliği yaptığı tarihi bir anı işaret ediyor. Bu toplantı, iklim eylemini hızlandırmak, küresel iş birliğini güçlendirmek ve sürdürülebilir bir geleceğe giden yolu çizmek için yaklaşık 200 ülkeyi bir araya getiriyor.',
    'what_is_cop': 'COP Nedir?',
    'what_is_cop_text': 'Taraflar Konferansı (COP), Birleşmiş Milletler İklim Değişikliği Çerçeve Sözleşmesi\'nin (UNFCCC) en üst karar alma organıdır. 1995\'ten bu yana COP, Kyoto Protokolü\'nden Paris Anlaşması\'na kadar ülkelerin küresel iklim politikalarını müzakere ettiği ve koordine ettiği platform olmuştur.',
    'why_antalya': 'Neden Antalya?',
    'why_antalya_text': 'Antalya, doğal güzellik ve iklim aciliyetinin mükemmel kesişimini temsil ediyor. Bir Akdeniz kapısı olarak Türkiye, kıtaları ve kültürleri birleştirerek küresel iklim diyaloğunu teşvik etmek için ideal bir ev sahibi oluyor.',
    
    // Turkey Commitments
    'turkey_commitments': 'Türkiye\'nin İklim Taahhütleri',
    'turkey_commitments_desc': 'COP 31 ev sahibi olarak Türkiye, iddialı ulusal hedefler ve bölgesel girişimlerle iklim eyleminde liderlik gösteriyor.',
    
    // Focus Areas
    'key_focus_areas': 'Ana Odak Alanları',
    'focus_subtitle': 'COP 31, dört stratejik sütun aracılığıyla kritik iklim zorluklarını ele alıyor',
    'renewable_energy': 'Yenilenebilir Enerjiye Geçiş',
    'mediterranean_bio': 'Akdeniz Biyoçeşitliliği',
    'sustainable_cities': 'Sürdürülebilir Şehirler',
    'climate_finance': 'İklim Finansmanı ve Adaleti',
    
    // Schedule
    'conference_schedule': 'Konferans Programı',
    'schedule_subtitle': 'Yoğun müzakereler, diyaloglar ve işbirlikçi eylemin on günü',
    
    // News
    'latest_news': 'Son Haberler ve Güncellemeler',
    'news_subtitle': 'COP 31 hazırlıkları ve iklim eylemi ilerlemesi hakkında bilgi sahibi olun',
    'view_all_news': 'Tüm Haberleri Gör',
    
    // Registration
    'join_us': 'COP 31\'e Katılın',
    'registration_desc': 'COP 31 için kayıt 2026 başında açılacaktır. Hükümetler, STK\'lar, özel sektör, medya ve gözlemciler için birden fazla katılım kategorisi mevcuttur.',
    'registration_requirements': 'Kayıt Gereksinimleri',
    'pre_register': 'Ön Kaydınızı Yapın',
    
    // Partners
    'partners_supporters': 'Ortaklar ve Destekçiler',
    
    // Footer
    'quick_links': 'Hızlı Bağlantılar',
    'contact': 'İletişim',
    
    // Ultra Admin
    'ultra_admin': 'Ultra Admin',
    'control_center': 'COP 31 Platform Kontrol Merkezi',
    'sign_in': 'Giriş Yap',
    'access_admin': 'Sistem yönetim paneline erişin',
    'email_address': 'E-posta Adresi',
    'password': 'Şifre',
    'remember_me': 'Beni hatırla',
    'forgot_password': 'Şifremi unuttum?',
    'signing_in': 'Giriş yapılıyor...',
    'pre_live_testing': 'Ön Test',
    'quick_access': 'Hızlı Erişim (Bypass)',
    'secure_admin': 'Güvenli admin erişimi.',
    'dashboard': 'Panel',
    'welcome_back': 'Hoş geldiniz, Ultra Admin',
    'logout': 'Çıkış',
    'loading_dashboard': 'Panel yükleniyor...',
    'total_tenants': 'Toplam Kiracı',
    'total_users': 'Toplam Kullanıcı',
    'total_products': 'Toplam Ürün',
    'total_orders': 'Toplam Sipariş',
    'active': 'aktif',
    'across_all': 'Tüm kiracılarda',
    'from_suppliers': 'Tedarikçilerden',
    'this_week': 'bu hafta',
    'system_overview': 'Sistem Genel Bakış',
    'customer_tenants': 'Müşteri Kiracılar',
    'supplier_tenants': 'Tedarikçi Kiracılar',
    'orgs_placing': 'Sipariş veren organizasyonlar',
    'orgs_providing': 'Ürün sağlayan organizasyonlar',
    'tenant_management': 'Kiracı Yönetimi',
    'user_management': 'Kullanıcı Yönetimi',
    'user_categories': 'Kullanıcı Kategorileri',
    'add_tenant': 'Kiracı Ekle',
    'add_user': 'Kullanıcı Ekle',
    'no_tenants': 'Kiracı bulunamadı',
    'no_users': 'Kullanıcı bulunamadı',
    'customer_tenants': 'Müşteri Kiracıları',
    'supplier_tenants': 'Tedarikçi Kiracıları',
    'orgs_placing': 'Sipariş veren kuruluşlar',
    'orgs_providing': 'Ürün sağlayan kuruluşlar',
    'made_with': 'Emergent ile yapılmıştır',
    
    // Customer/Supplier common
    'my_products': 'Ürünlerim',
    'my_orders': 'Siparişlerim',
    'profile': 'Profil',
    'browse_products': 'Ürünlere Gözat',
    'search_products': 'Ürün ara...',
    'category': 'Kategori',
    'all_categories': 'Tüm Kategoriler',
    'price': 'Fiyat',
    'stock': 'Stok',
    'add_to_cart': 'Sepete Ekle',
    'view_details': 'Detayları Gör',
    'create_order': 'Sipariş Oluştur',
    'order_history': 'Sipariş Geçmişi',
    'order_id': 'Sipariş ID',
    'order_date': 'Sipariş Tarihi',
    'total_amount': 'Toplam Tutar',
    'status': 'Durum',
    'items': 'Ürünler',
    'supplier': 'Tedarikçi',
    'customer': 'Müşteri',
    'quantity': 'Miktar',
    'unit_price': 'Birim Fiyat',
    'subtotal': 'Ara Toplam',
    'add_product': 'Ürün Ekle',
    'edit_product': 'Ürünü Düzenle',
    'delete_product': 'Ürünü Sil',
    'product_name': 'Ürün Adı',
    'description': 'Açıklama',
    'save': 'Kaydet',
    'cancel': 'İptal',
    'confirm': 'Onayla',
    'update_status': 'Durumu Güncelle',
    'in_progress': 'İşlemde',
    
    // Green Zone Layout  
    'blue_zone_layouts': 'Blue Zone Layout Yönetimi',
    'add_participant': 'Katılımcı Ekle',
    'participant_email': 'Katılımcı E-posta',
    'country': 'Ülke',
    'select_country': 'Ülke Seçiniz',
    'authorized_persons': 'Yetkili Kişiler',
    'full_name': 'Ad Soyad',
    'mobile_phone': 'Mobil Telefon',
    'phone': 'Telefon',
    'email': 'E-posta',
    'title': 'Unvan',
    'add_person': 'Kişi Ekle',
    'create_layout': 'Layout Oluştur',
    'layout_wizard': 'Layout Sihirbazı',
    'base_dimensions': 'Ana Boyutlar',
    'width_m': 'En (m)',
    'height_m': 'Boy (m)',
    'add_indent': 'Girinti Ekle',
    'add_extrusion': 'Çıkıntı Ekle',
    'open_sides': 'Açık Kenarlar',
    'north': 'Kuzey',
    'south': 'Güney',
    'east': 'Doğu',
    'west': 'Batı',
    'total_area': 'Toplam Alan',
    'preview': 'Ön İzleme',
    'my_layout': 'Stand Planım',
    'all_participants': 'Tüm Katılımcılar'
  }
};

export const useTranslations = (language) => {
  return (key) => {
    return translations[language]?.[key] || translations.en[key] || key;
  };
};
